import {
  Box,
  Button,
  MenuItem,
  Select,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  ArrowRight,
  CalendarFill,
  ClockFill,
  GeoAltFill,
  PersonFill,
} from "react-bootstrap-icons";
import styles from "./form.module.css";
import TypeForm from "../TypeForm/TypeForm";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { v4 as uuidv4 } from "uuid";
import { filterPaymentMethods } from "../../utils/Filters";

function ViewForm({
  userDetails,
  availableViewTypes,
  availableDiscountReason,
  availablePaymentMethods,
  setCurrentStep,
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [views, setViews] = useState([]);

  const [selectedPayment, setSelectedPayment] = useState("");
  const [typeForms, setTypeForms] = useState([]);
  useEffect(() => {
    if (userDetails && userDetails.paymentMethods.length > 0) {
      setTypeForms(
        userDetails.paymentMethods.map((p) => ({
          ...p,
          identifier: uuidv4(),
        }))
      );
    }
  }, [userDetails]);

  const handleAddTypeForm = () => {
    if (!selectedPayment) return;

    setTypeForms((prev) => [
      ...prev,
      {
        identifier: uuidv4(),
        ...selectedPayment,
      },
    ]);
  };

  const handleDelete = (id) => {
    if (typeForms.length <= 1) {
      toast.error("يجب تعبئة نوع واحد على الأقل");
      return;
    }
    setTypeForms((prev) => prev.filter((form) => form.identifier !== id));
  };

  const handleViewChange = (index, updatedView) => {
    setViews((prev) => {
      let newViews = prev.filter(
        (v) => v.identifier !== updatedView.identifier
      );
      newViews.push(updatedView);
      return newViews;
    });
  };
  const handleSubmit = async () => {
    setLoading(true);

    let newErrors = [];

    views.forEach((view) => {
      newErrors[view.identifier] = {};
      if (view.discounted) {
        if (view.amount === view.netAmount) {
          newErrors[view.identifier].amount =
            "تم تفعيل الخصم بدون تغيير المبلغ النهائي. ";
        }
        if (view.discountReason === "سبب آخر" && view.customReason === "")
          newErrors[view.identifier].customReason = "سبب الخصم المخصص مطلوب.";
        if (view.discountReason === "" && view.DiscountReasonId === null)
          newErrors[view.identifier].discountReason = "سبب الخصم مطلوب.";
      }
    });
    const errorArray = Object.values(newErrors);

    const hasErrors = errorArray.some((error) => {
      return error && Object.keys(error).length > 0;
    });

    if (hasErrors) {
      setErrors(newErrors);
      setLoading(false);
      return;
    }

    setLoading(false);
    try {
      const filteredViews = views.filter((view) => view.quantity !== 0);
      if (filteredViews.length === 0) {
        toast.error("يجب تعبئة نوع واحد على الأقل.");
        setLoading(false);
        return;
      }
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/view/batch`,
        { views: filteredViews },
        { withCredentials: true }
      );

      if (res) {
        navigate("/app/views/");
        toast.success("تم إضافة المشاهدات بنجاح!");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error.message);
    }
  };

  let availablePayments = [];
  availablePayments = filterPaymentMethods(
    userDetails.site.name,
    availablePaymentMethods
  );
  return (
    <div>
      <Box>
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Button
            onClick={() => setCurrentStep((prev) => prev - 1)}
            variant="contained"
            sx={{
              width: "48px",
              height: "48px",
              padding: 0,
              margin: 0,
              minWidth: "auto",
              marginRight: "12px",
            }}
          >
            <ArrowRight size={24} />
          </Button>
          <Typography
            variant="h4"
            color={theme.palette.neutral[900]}
            fontWeight={700}
          >
            إضافة مشاهدات جديدة
          </Typography>
        </div>
        <Box className={styles.formSection}>
          <Typography
            variant="h5"
            color={theme.palette.neutral[800]}
            fontWeight={600}
            marginBottom={2}
          >
            معلومات الموظف
          </Typography>
          <Box sx={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            <div className={styles.details}>
              <PersonFill color={theme.palette.neutral[700]} />
              <Typography
                variant="body1"
                color={theme.palette.neutral[800]}
                fontWeight={600}
              >
                {userDetails.user.name}
              </Typography>
            </div>
            <div className={styles.details}>
              <CalendarFill color={theme.palette.neutral[700]} />
              <Typography
                variant="body1"
                color={theme.palette.neutral[800]}
                fontWeight={600}
              >
                {userDetails.date.format("YYYY-MM-DD")}
              </Typography>
            </div>
            <div className={styles.details}>
              <GeoAltFill color={theme.palette.neutral[700]} />
              <Typography
                variant="body1"
                color={theme.palette.neutral[800]}
                fontWeight={600}
              >
                {userDetails.site.name}
              </Typography>
            </div>
            <div className={styles.details}>
              <ClockFill color={theme.palette.neutral[700]} />
              <Typography
                variant="body1"
                color={theme.palette.neutral[800]}
                fontWeight={600}
              >
                {userDetails.worktime.duration}
              </Typography>
            </div>
          </Box>
        </Box>
        <div className="forms">
          {typeForms.length > 0 &&
            typeForms?.map((p, i) => {
              return (
                <TypeForm
                  onViewChange={handleViewChange}
                  availableDiscountReason={availableDiscountReason}
                  availableViewTypes={availableViewTypes}
                  key={i}
                  handleDelete={handleDelete}
                  payment={p}
                  userDetails={userDetails}
                  errors={errors}
                />
              );
            })}
        </div>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            padding: "24px",
            gap: "20px",
            justifyContent: "space-between",
            flexDirection: { xs: "column", md: "row" },
            background: "white",
            borderRadius: "20px",
            marginBottom: "20px",
          }}
        >
          <Box
            display={"flex"}
            sx={{
              width: { xs: "100%", md: "80%" },
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "start", md: "center" },
            }}
            gap={2}
            alignItems={"center"}
          >
            <Typography>إضافة بيانات أخرى</Typography>
            <Select
              value={selectedPayment || ""}
              onChange={(e) => setSelectedPayment(e.target.value)}
              sx={{ maxWidth: { md: "300px" }, width: "100%" }}
            >
              {availablePayments.length > 0 &&
                availablePayments.map((p, i) => (
                  <MenuItem key={i} value={p}>
                    {p.name}
                  </MenuItem>
                ))}
            </Select>
          </Box>
          <Button
            variant="contained"
            onClick={handleAddTypeForm}
            sx={{ color: theme.palette.primary[500], background: "#333" }}
          >
            إضافة
          </Button>
        </Box>
      </Box>
      <Box>
        <LoadingButton
          loading={loading}
          variant="contained"
          color="primary"
          sx={{ fontSize: "20px" }}
          fullWidth
          onClick={handleSubmit}
        >
          إضافة
        </LoadingButton>
      </Box>
    </div>
  );
}

export default ViewForm;
